/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Channel_Detail_TitleInputs */



/**
* | output |
* | --- |
* | "Channel" |
*
* @param {View_Channel_Detail_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const view_channel_detail_title = /** @type {((inputs?: View_Channel_Detail_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Channel_Detail_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Канал")
	return /** @type {LocalizedString} */ ("Channel")
});